<div id="int-presence-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.presence.title' | translate">
    @if (api.hasPermission('create_presence')) {
      <reactive-button
        actions
        [label]="'internal.presence.newPresence' | translate"
        icon="add"
        variant="outlined"
        (onClick)="newPresence()"
      ></reactive-button>
    }
  </app-internal-toolbar>

  <p-tabs [value]="schoolyears()[schoolyears().length - 1]">
    <p-tablist>
      @if (loadingPresence()) {
        <p-skeleton width="5.5rem" height="1.5625rem" class="m-4" />
        <p-skeleton width="5.5rem" height="1.5625rem" class="m-4" />
        <p-skeleton width="5.5rem" height="1.5625rem" class="m-4" />
      } @else {
        @for (tab of schoolyears(); track tab) {
          <p-tab [value]="tab">{{ tab + ' - ' + (tab + 1) }}</p-tab>
        }
      }
    </p-tablist>
    <p-tabpanels>
      @for (tab of schoolyears(); track tab) {
        <p-tabpanel [value]="tab">
          <div class="flex flex-row items-center gap-2">
            <p-toggleswitch
              [ngModel]="showHiddenUsers()"
              (ngModelChange)="showHiddenUsers.set($event)"
            />
            <span>{{ 'general.showHiddenUsers' | translate }}</span>
          </div>
          <div id="int-presence-legend-grid">
            @for (pres of [0, 3, 4, 5, -1]; track pres; let i = $index) {
              <div class="int-presence-col">
                <div class="int-presence-cell" [style.background]="getPresenceColor(pres)">
                  <mat-icon iconClass="noselect">{{ getPresenceIcon(pres) }}</mat-icon>
                </div>
                <div class="int-presence-cell">
                  <div class="noselect" style="font-size: 16px">
                    {{ 'internal.presence.tooltips.' + pres | translate }}
                  </div>
                </div>
                <div></div>
              </div>
            }
          </div>

          @if (loadingPresence()) {
            <p-skeleton height="20rem" class="mt-4"/>
          } @else {
            <div id="int-presence-grid">
              <!-- Date Title -->
              <div class="int-presence-cell" [style.grid-area]="'1 / 1'">
                <div class="noselect">
                  {{ 'internal.presence.date' | translate }}
                </div>
              </div>

              <!-- Usernames -->
              @for (username of usersPerYear()[tab + '']; track username; let i = $index) {
                <div class="int-presence-cell" [style.grid-area]="i + 2 + ' / 1'">
                  @if (loadingUsers()) {
                    <p-skeleton width="7rem" height="2rem" class="m-auto mt-2" />
                  } @else {
                    <div class="noselect text-base flex items-center justify-center gap-2">
                      @if (getUserName(username) == username) {
                        <mat-icon iconClass="noselect">delete</mat-icon>
                      }
                      @if (getUserHidden(username)) {
                        <mat-icon iconClass="noselect">visibility_off</mat-icon>
                      }
                      {{ getUserName(username) }}
                    </div>
                  }
                </div>
              }

              <!-- Presence information -->
              @for (pres of presencePerYear()[tab + '']; track pres; let o = $index) {
                <div class="int-presence-col">
                  <div class="int-presence-cell" [style.grid-area]="'1 / ' + (o + 2)">
                    <div class="noselect text-vertically">
                      <!-- <div class="int-presence-date-start">
                      {{ pres.startdate | date: 'd. MMM y, HH:mm' }}
                    </div>
                    <div class="int-presence-date-end">
                      {{ pres.enddate | date: 'd. MMM y, HH:mm' }}
                    </div> -->
                      <div class="int-presence-date-start text-left mt-8">
                        {{ pres.startdate | date: 'd. MMM y' }}
                      </div>
                      <div class="int-presence-date-end text-left mt-8">
                        {{ pres.startdate | date: 'HH:mm' }}
                      </div>
                    </div>
                  </div>

                  @for (username of usersPerYear()[tab + '']; track username; let i = $index) {
                    <div
                      class="int-presence-cell"
                      [style.grid-area]="i + 2 + ' / ' + (o + 2)"
                      [style.background]="getUserColor(pres, username)"
                    >
                      <mat-icon iconClass="noselect">{{ getUserIcon(pres, username) }}</mat-icon>
                    </div>
                  }
                  <div
                    [class.touch]="canEdit(pres)"
                    [routerLink]="canEdit(pres) ? pres._id : './'"
                    routerLinkActive="active"
                    [style.grid-area]="
                      '1 / ' + (o + 2) + ' / span ' + (usersPerYear()[tab + ''].length + 1)
                    "
                  ></div>
                </div>
              }

              <!-- user Percentage Title -->
              <div
                class="int-presence-cell"
                [style.grid-area]="'1 / ' + (presencePerYear()[tab + ''].length + 2)"
                style="background-color: rgba(255, 255, 255, 0.1)"
              >
                <div class="noselect text-vertically">
                  {{ 'internal.presence.percentage' | translate }}
                </div>
              </div>

              <!-- User Percentage -->
              @for (username of usersPerYear()[tab + '']; track username; let i = $index) {
                <div
                  class="int-presence-cell"
                  [style.grid-area]="i + 2 + ' / ' + (presencePerYear()[tab + ''].length + 2)"
                  style="background-color: rgba(255, 255, 255, 0.1)"
                >
                  <div class="noselect" style="font-size: 16px">
                    {{ getUserPercentage(username, tab) + '%' }}
                  </div>
                </div>
              }
            </div>
          }
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</div>
